"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const baseTheme_1 = __importDefault(require("../baseTheme"));
const defaultTheme = (0, baseTheme_1.default)();
exports.default = (0, styled_components_1.createGlobalStyle) `
  @import url('./normalize.css');
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,300');
  @import url('../baseTheme');
  html { font-family: "Open Sans", sans-serif; fonti-size: 16px }

  body {
    background: ${defaultTheme.colors.body.background};
    color: ${defaultTheme.colors.body.text};
  }

  a {
    text-decoration: none;
  }
`;
//# sourceMappingURL=index.js.map